import { Button, Text, VStack } from "@chakra-ui/react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";
import { useAuthStore } from "../store";
import { colors } from "../styles";

export default function ErrorElement() {

    const error = useRouteError();
    const { isLoggedIn, isAdmin } = useAuthStore();

    const homePath = isLoggedIn ? (isAdmin ? "/admin/main" : "/home") : "/";
    const isNotFoundError = !error || (isRouteErrorResponse(error) && error.status === 404);

    /* render */

    return (
        <VStack
            width={"100%"}
            minHeight={"100vh"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={5}
            padding={5}
            textAlign={"center"}
        >
            {isNotFoundError ? 
                <Text fontSize={24} fontWeight={700} color={colors.black}>
                    요청하신 페이지를 찾을 수 없습니다
                </Text>
                :
                <Text fontSize={24} fontWeight={700} color={colors.black}>
                    페이지를 불러오지 못했습니다
                </Text>
            }

            {isNotFoundError ? 
                <Text fontSize={15} fontWeight={400} lineHeight={2} color={colors.g2}>
                    주소가 잘못 입력되었거나,<br />페이지가 이동 또는 삭제되었을 수 있습니다.
                </Text> 
                : 
                <Text fontSize={15} fontWeight={400} lineHeight={2} color={colors.g2}>
                    일시적인 문제가 발생했습니다.<br />잠시 후 다시 시도하거나 홈으로 돌아가 주세요.
                </Text>
            }
            

            <Link to={homePath}>
                <Button
                    backgroundColor={colors.blue}
                    color={colors.white}
                    _hover={{ backgroundColor: colors.dark }}
                >
                    홈으로 가기
                </Button>
            </Link>
        </VStack>
    );
}
